import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { v4 as uuidv4 } from "uuid";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GetSaleOrderDtoWIthType } from "../../../../core/models/orders/getSaleOrderDtoWIthType";
import { GetSalesOrderWithLinesDto } from "../../../../core/models/orders/getSalesOrderWithLinesDto";
import { SalesOrderLine } from "../../../../core/models/orders/saleOrderLine";
import { SaleOrderLinePortalKeyDto } from "../../../../core/models/orders/saleOrderLinePortalKeyDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { EnumCopiedFrom } from "../../../../shared/enums/copied-From.enum";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { AccordionModule } from "primeng/accordion";
import { CopyLinesService } from "../../../../core/services/copy-lines.service";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { QuotesLinePortalKeyDto } from "../../../../core/models/qoutes/quotesLinePortalKeyDto";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { CopyLinesDto } from "../../../../core/models/orders/copyLinesDto";
import { CopyLinesQuotesDto } from "../../../../core/models/qoutes/copyLinesQuotesDto";
import { ButtonModule } from "primeng/button";
@UntilDestroy()
@Component({
  selector: "jni-copy-lines",
  templateUrl: "./copy-lines.component.html",
  styleUrls: ["./copy-lines.component.scss"],
  imports: [
    DialogModule,
    TableModule,
    CommonModule,
    AccordionModule,
    HidedynamicsdatePipe,
    ButtonModule,
  ],
})
export class CopyLinesComponent {
  @Input() saleOrderId = "";
  @Input() displayModal = false;
  @Output() closeDialogEvent = new EventEmitter();
  @Output() refreshGridEvent = new EventEmitter();
  @Input() isFromQuotesSummary = false;

  salesOrderHeader: GetSaleOrderDtoWIthType[] = [];
  quoteListings: GetSaleOrderDtoWIthType[] = [];
  salesOrderLine: SalesOrderLine[] = [];

  SOLinesItem: string[] = [];
  QuotesLinesItem: string[] = [];

  selectedSalesOrderLine!: SalesOrderLine[];
  selectedSalesOrderHeader!: GetSaleOrderDtoWIthType[];
  getSalesOrderWithLinesDto: GetSalesOrderWithLinesDto[] = [];
  saleOrder: GetSalesOrderWithLinesDto[] = [];

  constructor(
    private _copyLinesService: CopyLinesService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _createHeaderQuoteService: CreateHeaderQuoteService
  ) {}

  closeDialog() {
    this.selectedSalesOrderHeader = [];
    this.selectedSalesOrderLine = [];
    this.closeDialogEvent.emit();
  }

  getSaleOrder() {
    this._loaderService.setLoaderState(true);
    this._copyLinesService.GetAllSalesOrderWithLines().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        const lineArray: GetSaleOrderDtoWIthType[] = [];
        if (res.data) {
          this.getSalesOrderWithLinesDto = res.data;
          this.getSalesOrderWithLinesDto.forEach(element => {
            if (element.getSaleOrdersDto) {
              lineArray.push(element.getSaleOrdersDto);
            }
          });
          this.salesOrderHeader = lineArray;
          this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this.selectedSalesOrderLine = [];
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getAllSalesOrderHeader() {
    this.salesOrderHeader = [];
    this.salesOrderLine = [];
    this.SOLinesItem = [];
    this.QuotesLinesItem = [];
    this.selectedSalesOrderLine = [];
    this.selectedSalesOrderHeader = [];

    this._loaderService.setLoaderState(true);
    this._copyLinesService.getAllSalesOrderHeader().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.salesOrderHeader = res.data;
          this._loaderService.setLoaderState(false);
          if (this.quoteListings.length > 0) {
            this.salesOrderHeader.push(...this.quoteListings);
          }
        }
      },
      error: () => {
        this.selectedSalesOrderLine = [];
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getAllQuoteHeader() {
    this._createHeaderQuoteService
      .getAllQuotesAndCombineItInSalesHeader()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.quoteListings = res.data;
          if (res?.data && res?.data?.length > 0) {
            this.quoteListings = res.data;
          }

          if (this.salesOrderHeader.length > 0) {
            this.salesOrderHeader.push(...this.quoteListings);
          }
        },
        error: res => {
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  save() {
    if (this.isFromQuotesSummary) {
      this.saveQuotesLines();
    } else {
      this._loaderService.setLoaderState(true);
      const linesArray: SaleOrderLinePortalKeyDto[] = [];
      this.selectedSalesOrderLine.forEach(x => {
        const line: SaleOrderLinePortalKeyDto = {
          ...x,
          oldPortalKey: x.portalKeyD365,
          portalKeyD365: uuidv4(),
        };
        linesArray.push(line);
      });

      const copyLineArray: CopyLinesDto = {
        saleOrderLinePortalKeyDtos: linesArray,
        salesOrderId: this.saleOrderId,
      };

      this.selectedSalesOrderHeader = [];
      this.selectedSalesOrderLine = [];

      this._copyLinesService
        .addLineData(copyLineArray)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.refreshGridEvent.emit();
              this._toastr.success("Success", res.message);
              this.closeDialog();
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error adding line item"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message ?? "Error adding line item"
            );
          },
        });
    }
  }
  saveQuotesLines() {
    this._loaderService.setLoaderState(true);
    const linesArray: QuotesLinePortalKeyDto[] = [];

    this.selectedSalesOrderLine.forEach(x => {
      const line: QuotesLinePortalKeyDto = {
        ...x,
        lineCopiedFrom: x.lineCopiedFrom ?? 0,
        sellTotalD365:
          x.sellTotalD365 !== null ? Number(x.sellTotalD365) : null,
        sellConversion:
          x.sellConversion !== null ? Number(x.sellConversion) : null,
        sellConversionTotal:
          x.sellConversionTotal !== null ? Number(x.sellConversionTotal) : null,
        oldPortalKey: x.portalKeyD365 ?? "",
        portalKeyD365: uuidv4(),
      };
      linesArray.push(line);
    });

    const copyLineArray: CopyLinesQuotesDto = {
      quotesLinePortalKeyDtos: linesArray,
      quotesId: this.saleOrderId,
    };
    this.selectedSalesOrderLine = [];

    this._createHeaderQuoteService
      .addLineData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.refreshGridEvent.emit();
            this._toastr.success("Success", res.message);
            this.closeDialog();
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding line item"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding line item");
        },
      });
  }

  getLineAgainstHeader() {
    this.salesOrderLine = [];
    if (
      this.selectedSalesOrderHeader &&
      this.selectedSalesOrderHeader.length > 0
    ) {
      const linesArray: SalesOrderLine[] = [];
      this.selectedSalesOrderHeader.forEach(x => {
        const index = this.getSalesOrderWithLinesDto.findIndex(
          y => y.getSaleOrdersDto?.salesOrderIdD365 == x.salesOrderIdD365
        );
        if (index > -1) {
          this.getSalesOrderWithLinesDto[index].salesOrderLines?.forEach(a => {
            linesArray.push(a);
          });
        }
      });
      this.salesOrderLine = linesArray;
    }
  }

  getLineAgainstSaleOrderHeader(salesOrderIdD365: string) {
    this._loaderService.setLoaderState(true);
    this._copyLinesService
      .getLineAgainstSaleOrderHeader(salesOrderIdD365 || "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            const data = res.data;
            if (data?.salesOrderLine) {
              let getsaleOrderLine: SalesOrderLine[] = [];
              getsaleOrderLine = data.salesOrderLine;
              if (getsaleOrderLine.length > 0) {
                getsaleOrderLine.forEach(element => {
                  element.lineCopiedFrom = data.lineFrom;
                  this.salesOrderLine.push(element);
                });
              }
            }
          } else {
            this._toastr.error("Error", res.message || "No line item found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No line item found");
        },
      });
  }

  getLineAgainstQuotesHeader(salesOrderIdD365: string) {
    this._loaderService.setLoaderState(true);
    this._copyLinesService
      .getLineAgainstQuoteHeader(salesOrderIdD365 || "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            const data = res.data;
            if (data?.salesOrderLine) {
              let getsaleOrderLine: SalesOrderLine[] = [];
              getsaleOrderLine = data.salesOrderLine;
              if (getsaleOrderLine.length > 0) {
                getsaleOrderLine.forEach(element => {
                  element.lineCopiedFrom = data.lineFrom;
                  this.salesOrderLine.push(element);
                });
              }
            }
          } else {
            this._toastr.error("Error", res.message || "No line item found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No line item found");
        },
      });
  }

  newSalesOrderLineArray: SalesOrderLine[] = [];
  newSelectedSalesOrderLineArray: SalesOrderLine[] = [];

  deleteUnselectedLines() {
    this.newSalesOrderLineArray = [];
    this.newSelectedSalesOrderLineArray = [];
    this._loaderService.setLoaderState(true);
    if (this.saleOrderIdArray.length > 0) {
      this.saleOrderIdArray?.forEach(x => {
        this.salesOrderLine?.forEach(y => {
          if (y.salesOrderIdD365 === x) {
            this.newSalesOrderLineArray.push(y);
          }
        });
        this.selectedSalesOrderLine?.forEach(y => {
          if (y.salesOrderIdD365 === x) {
            this.newSelectedSalesOrderLineArray.push(y);
          }
        });
      });
    }

    this.salesOrderLine = [];
    this.salesOrderLine = this.newSalesOrderLineArray;
    this.selectedSalesOrderLine = [];
    this.selectedSalesOrderLine = this.newSelectedSalesOrderLineArray;
    this.onLineSelect();
    this._loaderService.setLoaderState(false);
  }

  onLineSelect() {
    const SOLinesItem: string[] = [];
    const quotesLinesItem: string[] = [];
    this.selectedSalesOrderHeader.forEach(x => {
      const lines = this.selectedSalesOrderLine.filter(
        y => y.salesOrderIdD365 == x.salesOrderIdD365
      );
      lines.forEach(line => {
        if (
          x.type?.toLowerCase() == "quotes" ||
          line?.lineCopiedFrom == EnumCopiedFrom.IsFromQuote
        ) {
          quotesLinesItem.push(line.externalItemNumberD365 ?? "");
        } else {
          SOLinesItem.push(line.externalItemNumberD365 ?? "");
        }
      });
    });
    this.QuotesLinesItem = quotesLinesItem;
    this.SOLinesItem = SOLinesItem;
  }

  saleOrderIdArray: string[] = [];
  selectRow(
    checkValue: boolean,
    salesOrderIdD365: string,
    headerFrom?: number
  ) {
    if (checkValue) {
      this.saleOrderIdArray.push(salesOrderIdD365);
      if (headerFrom && headerFrom == EnumCopiedFrom.IsFromQuote) {
        this.getLineAgainstQuotesHeader(salesOrderIdD365);
      } else {
        this.getLineAgainstSaleOrderHeader(salesOrderIdD365);
      }
    } else {
      const index = this.saleOrderIdArray.indexOf(salesOrderIdD365);
      this.saleOrderIdArray.splice(index, 1);
      this.deleteUnselectedLines();
    }
  }
}
